<div layout="column">
  <div layout="row"
    layout-align="space-between center"
    flex>
    <span [translate]="'tags.addTag'"
      mat-dialog-title
    class="mat-dialog-title-padding">Add tag</span>
    <div layout="row">
      <itfg-tag-settings-button></itfg-tag-settings-button>
      <button tabindex="-1"
        class="close-mat-dialog"
        mat-icon-button
        [mat-dialog-close]="false">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>

  <form layout="column"
    (ngSubmit)="onSave($event)">
    <mat-form-field flex>
      <input type="text"
        placeholder="{{ 'tags.tag' | translate }}"
        [style.color]="tagControl.value?.color"
        matInput
        itfgSelectFirstAutocompleteOptionOnBlur
        [formControl]="tagControl"
        [matAutocomplete]="auto">
        <mat-label>{{ 'tags.tag' | translate }}</mat-label>
        <mat-autocomplete #auto="matAutocomplete"
          autoActiveFirstOption
          [displayWith]="mapTagToDisplayValue">
          @for (tag of filteredShownTags$ | async; track tag) {
            <mat-option
              [value]="tag">
              <span [style.color]="tag.color">{{tag.name}}</span>
            </mat-option>
          }
        </mat-autocomplete>
        @if (tagControl.hasError('required')) {
          <mat-error
            [translate]="'forms.required'">This field is required
          </mat-error>
        }
        @if (tagControl.hasError('notValidTag')) {
          <mat-error
          [translate]="'forms.notValidTag'"></mat-error>
        }
      </mat-form-field>

      <div layout="row"
        layout-align="end center"
        class="action-buttons">
        <button mat-raised-button
          color="primary"
          type="submit">
          <span [translate]="'global.save'">Save</span>
        </button>
      </div>
    </form>
  </div>
